import { Directive, TemplateRef, inject, input } from '@angular/core';

/** Context passed to a projected [gridCell] template. */
export interface GridCellContext<T = unknown> {
  /** The row (also available as the microsyntax default, `let-row`). */
  $implicit: T;
  row: T;
  /** The column's resolved value (`col.value(row)` or `row[key]`). */
  value: unknown;
}

/**
 * Declares a custom cell renderer for one column, matched by key:
 *
 *   <ng-template gridCell="status" let-row let-value="value"> … </ng-template>
 *
 * The type-safe replacement for the legacy table's `customRender` string +
 * [innerHTML]. The static context guard narrows `let-row` to `T` at the call
 * site (where the grid's generic is known).
 */
@Directive({
  selector: 'ng-template[gridCell]',
})
export class GridCellDirective<T = unknown> {
  /** The column key this template renders. */
  readonly gridCell = input.required<string>();

  readonly template = inject<TemplateRef<GridCellContext<T>>>(TemplateRef);

  static ngTemplateContextGuard<T>(
    _dir: GridCellDirective<T>,
    _ctx: unknown,
  ): _ctx is GridCellContext<T> {
    return true;
  }
}
